var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "context_info",
    },
    [
      _c(
        "a",
        {
          staticClass: "followunfollow",
          class: {
            unfollowed: !_vm.followed,
          },
          attrs: {
            href: "#",
            title: _vm.$gettext(
              "Benachrichtigungen für diese Konversation abstellen."
            ),
          },
          on: {
            click: function click($event) {
              $event.preventDefault()
              return _vm.onClick.apply(null, arguments)
            },
          },
        },
        [
          !_vm.followed
            ? _c("StudipIcon", {
                staticClass: "text-bottom",
                attrs: {
                  shape: "decline",
                  size: 20,
                },
              })
            : _c("StudipIcon", {
                staticClass: "text-bottom",
                attrs: {
                  shape: "notification2",
                  size: 20,
                },
              }),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$gettext("Benachrichtigungen aktiviert")) +
              "\n    "
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }